module.exports = __webpack_public_path__ + "Lato-Light.db684ad3a23ea29e7f80.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Light.eot
// module id = ../../../../../src/assets/fonts/Lato-Light.eot
// module chunks = styles